import { Loader } from '@/components/loader/loader';
import { AutomaticUploadFileButton } from '@/features/action-panel/files/automatic-upload-file-button';
import { FilesDragDrop } from '@/features/files-drag-drop/files-drag-drop';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { styled } from 'goober';
import { useDrag } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import SvgFiles from '@/assets/widgets/empty-state-files.svg';

const allowedExtensions = ['xlsx', 'xls'];

type LoadCompaniesToProjectDragDropProps = {
  isLoading: boolean;
  onDrop: (files: globalThis.File[]) => void;
};

export const LoadCompaniesToProjectDragDrop = ({
  onDrop,
  isLoading,
}: LoadCompaniesToProjectDragDropProps) => {
  const [{ draggingItems }] = useDrag({
    type: NativeTypes.FILE,
    canDrag: true,
    collect: monitor => ({
      draggingItems: monitor.getItem(),
    }),
  });

  if (isLoading) {
    return <Loader />;
  }
  return draggingItems ? (
    <Flexbox
      name="action-panel-button-container"
      justify="right"
      alignItems="center"
      height="56px"
    >
      <FilesDragDrop onDrop={onDrop} allowedExtensions={allowedExtensions} />
    </Flexbox>
  ) : (
    <Flexbox
      name="action-panel-button-container"
      justify="right"
      alignItems="center"
    >
      <Container
        name="action-panel-empty"
        grow="1"
        gap="29px"
        direction="column"
        alignItems="center"
        justify="center"
      >
        <img src={SvgFiles} />
        <AutomaticUploadFileButton
          onSubmit={onDrop}
          variant="primary"
          acceptedFiles={allowedExtensions}
        />
      </Container>
    </Flexbox>
  );
};

const Container = styled(Flexbox)`
  background-color: ${({ theme }) => theme.colors.basics.white};
`;
